import { render, staticRenderFns } from "./detalhe.vue?vue&type=template&id=06b66f79&"
import script from "./detalhe.vue?vue&type=script&lang=js&"
export * from "./detalhe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports